import { render, staticRenderFns } from "./App.vue?vue&type=template&id=53246341&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=53246341&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53246341",
  null
  
)

export default component.exports